import axiosInstance from "../../api/auth/axiosInstance";
export const FetchCategory = {
  fetchCategory: async  () => {
  try {
    const response = await axiosInstance.get('/doctorsCategoryList/get-all/', { 
    headers: { authType: "PreLogin" } 
  })
    return response;
  } catch (error) {
    
    throw new Error(error);
  }
  },
};

export default FetchCategory;